import classNames from "classnames";
import * as React from "react";
import { Alert } from "react-bootstrap";
import { CSSProperties, FunctionComponent } from "react";

export interface ErrorCardProps {
  message?: string;
  sticky?: boolean;
}

const ErrorCard: FunctionComponent<ErrorCardProps> = ({ message, sticky }) => {
  if (!message) {
    return null;
  }

  const className = classNames("text-center mb-3 mb-md-7 w-100", { "position-sticky": sticky });
  const style: CSSProperties = {};
  if (sticky) {
    style.top = 10;
    style.zIndex = 5;
  }

  return (
    <Alert variant={"danger"} className={className} style={style}>
      <span>{message}</span>
    </Alert>
  );
};

export default ErrorCard;
